import { useCallback } from "react"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { usePreVisitTracking } from "./usePreVisitTracking"

export function usePhotoIdTracking() {
  const { track } = usePreVisitTracking()
  const onImageAdded = useCallback(
    (side: "front" | "back") =>
      track(side === "front" ? MemberActions.ID_UPLOAD_FRONT_ADDED : MemberActions.ID_UPLOAD_BACK_ADDED),
    [track]
  )
  const onUploadCompleted = useCallback(() => track(MemberActions.ID_UPLOAD_COMPLETED), [track])

  return { onImageAdded, onUploadCompleted }
}
